//Adapted from the C# code here: http://www.singular.co.nz/2007/12/shortguid-a-shorter-and-url-friendly-guid-in-c-sharp/
var UUID = require("uuid-js");

var replaceAll = function(string, search, replacement) {
  var target = string;
  return target.split(search).join(replacement);
};

var ShortGuids = {};

ShortGuids.encode = function (guid) {
  if (!guid.toBytes)
    guid = UUID.fromURN(guid);
  var byteArray = guid.toBytes();
  var encoded = btoa(String.fromCharCode.apply(null, byteArray));
  encoded = replaceAll(encoded, "/", "_");
  encoded = replaceAll(encoded, "+", "-");
  return encoded.substring(0, 22);
};

ShortGuids.decode = function(shortGuid) {
  shortGuid = replaceAll(shortGuid, "_", "/");
  shortGuid = replaceAll(shortGuid, "-", "+");
  var guid = atob(shortGuid + "==");
  return UUID.fromBinary(guid).toString();
};

ShortGuids.generate = function () {
  var guid = UUID.create();

  return ShortGuids.encode(guid);
};

module.exports = ShortGuids;
